import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [

  {
    name: 'My Profile',
    url: '/myprofile',
    icon: 'icon-user',
    //children:[],
    // badge: {
    //   variant: 'info',
    //   text: 'NEW'
    // }
  },
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    //children:[],
    // badge: {
    //   variant: 'info',
    //   text: 'NEW'
    // }
  },
  {
    name: 'Trail test',
    url: '/trail-test',
    icon: 'icon-user',
  },

  
  // {
  //   name: 'My Test',
  //   url: '/mytest',
  //   icon: 'icon-book-open',
  //   //children:[],
  //   // badge: {
  //   //   variant: 'info',
  //   //   text: 'NEW'
  //   // }
  // },



];

/*if(dataManipSrvc.isadmin){
  navItems.push(
    {
      name: 'Admin ',
      url: '/admin',
      icon: 'icon-user',
      children:[
        {
          name: 'User Management ',
          url: '/usermanagement',
          icon: 'icon-user',
          
        },
        {
          name: 'Test Management ',
          url: '/testmanagement',
          icon: 'icon-user',
          
        },
      ],
      // badge: {
      //   variant: 'info',
      //   text: 'NEW'
      // }
    }
  )
}*/
